module.exports = __webpack_public_path__ + "img/cats-teaser.483318f6.jpg";